module.exports = __webpack_public_path__ + "static/media/d1b.a7256fda.png";